import angular from 'angular';
import AutoRefreshCheckComponent from './autoRefreshCheck.component';

const AutoRefreshCheck = angular.module('tinaba.common.autoRefreshCheck', [])

.component('autoRefreshCheck', AutoRefreshCheckComponent);

export default AutoRefreshCheck;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/autoRefreshCheck/autoRefreshCheck.js
 **/